import { useMutation } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'

import { graphql } from '~/gql'
import { useGraphQLRequest } from '~/hooks/useGraphQLRequest'
import { exists } from '~/utils'

import { useDocumentReportId } from './useDocumentReportId'

const document = graphql(`
  mutation DocumentReportEditPage_CloneDocumentReport($documentReportId: ID!) {
    copyDocument(documentId: $documentReportId) {
      id
    }
  }
`)

export const useCloneDocumentReportMutation = (
  options: MutationOptions<string, void> = {},
) => {
  const graphQLRequest = useGraphQLRequest()
  const documentReportId = useDocumentReportId()
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async () => {
      const result = await graphQLRequest({
        document,
        variables: { documentReportId },
      })
      const clonedDocumentReportId = result.copyDocument?.id
      if (!exists(clonedDocumentReportId)) {
        throw new Error(t('duplication_failed'))
      }

      return clonedDocumentReportId
    },
    ...options,
  })
}
